import { SVGProps, Ref, forwardRef } from 'react';

export const ClipOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.97 2.524a2.13 2.13 0 0 0-3.01 0L3.438 8.05a3.545 3.545 0 0 0 0 5.012 3.54 3.54 0 0 0 5.01 0l5.562-5.565.99.99-5.562 5.566a4.94 4.94 0 0 1-6.99 0 4.947 4.947 0 0 1 0-6.993L7.97 1.534a3.527 3.527 0 0 1 4.99 0 3.53 3.53 0 0 1 0 4.992l-5.524 5.526a2.116 2.116 0 0 1-2.99-2.991l4.852-4.854.99.99-4.852 4.854a.715.715 0 0 0 1.01 1.01l5.524-5.525a2.13 2.13 0 0 0 0-3.012"
                fill="currentColor"
            />
        </g>
    </svg>
));
ClipOutlinedSize16Glyph.displayName = 'ClipOutlinedSize16Glyph';
